'use client';

import { c as _c } from "react/compiler-runtime";
import './child-bio.scss';
import { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildBioDetails } from '../../molecules/child-bio-details/child-bio-details.tsx';
import { ChildBioImage } from '../../molecules/child-bio-image/child-bio-image.tsx';
export const ChildBioDisplay: React.FC<{
  details: ChildDetails;
  availability: ChildAvailabilityItem;
  seoLevel?: number;
}> = t0 => {
  const $ = _c(10);
  const {
    seoLevel: t1,
    details,
    availability
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== availability || $[1] !== details) {
    t2 = <div className="ChildBio__media"><ChildBioImage details={details} availability={availability} /></div>;
    $[0] = availability;
    $[1] = details;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== availability || $[4] !== details || $[5] !== seoLevel) {
    t3 = <div className="ChildBio__content"><ChildBioDetails seoLevel={seoLevel} details={details} availability={availability} /></div>;
    $[3] = availability;
    $[4] = details;
    $[5] = seoLevel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="ChildBio__flex flex">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};